<template>
  <header class="container">
    <SectionTab
      :value="section.name"
      :isActive="filterSubCategory === section.name"
      class="section-tab"
      v-for="section in availableSections"
      :key="section.name"
      @click="onSlectSection(section)"
    />
  </header>
</template>

<script>
import SectionTab from './section-tab';
export default {
  components: {
    SectionTab,
  },
  props: {
    availableSections: {
      type: Array,
      default: () => [],
    },
    selectedCategory: {
      type: String,
      default: '',
    },
    filterSubCategory: String,
  },
  methods: {
    onSlectSection(section) {
      this.$emit('section-selected', section);
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  overflow: hidden;
  max-height: 54px;
}

.section-tab + .section-tab {
  margin-left: 20px;
}
</style>
